(() => {
  if (window.QLSMobileMenuSearchFixV3Loaded) return;
  window.QLSMobileMenuSearchFixV3Loaded = true;

  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const root = document.documentElement;

  let toggle = null;
  let content = null;
  let scheduled = false;

  function cacheElements(scope = document) {
    const scopedToggle = scope.querySelector?.(
      '.main-menu__toggle[aria-controls="main-menu-content"]'
    );

    toggle = scopedToggle || document.querySelector(
      '.main-menu__toggle[aria-controls="main-menu-content"]'
    );

    content = document.getElementById('main-menu-content');
  }

  function isOpen() {
    if (!mobileQuery.matches || !toggle) return false;

    if (toggle.getAttribute('aria-expanded') === 'true') return true;

    if (!content) return false;

    return (
      content.hasAttribute('open') ||
      content.getAttribute('aria-hidden') === 'false' ||
      content.classList.contains('is-open') ||
      content.classList.contains('is-visible') ||
      content.classList.contains('active')
    );
  }

  function blurHeaderSearch() {
    if (Date.now() < Number(window.QLSMobileSearchHandoffUntil || 0)) return;
    const active = document.activeElement;
    if (!active?.closest) return;

    const search = active.closest(
      'form[action*="/search"], predictive-search, .header__search, .header-search, .search-bar, .site-search'
    );

    if (search) active.blur();
  }

  function sync() {
    scheduled = false;

    if (!toggle || !toggle.isConnected) {
      cacheElements();
    }

    const open = isOpen();
    root.classList.toggle('qls-mobile-menu-open', open);

    if (open) blurHeaderSearch();
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sync);
  }

  function eventTouchesMenu(event) {
    const target = event.target;
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest(
        '.main-menu__toggle, #main-menu-content, main-menu, [aria-controls="main-menu-content"]'
      )
    );
  }

  /*
    Enterprise updates aria-expanded during the menu click handler.
    The document-level bubble listener runs afterwards; one animation frame
    is enough to read the completed state. No interval or DOM observer needed.
  */
  document.addEventListener('click', (event) => {
    if (eventTouchesMenu(event)) scheduleSync();
  });

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' || eventTouchesMenu(event)) scheduleSync();
  });

  document.addEventListener('transitionend', (event) => {
    if (eventTouchesMenu(event)) scheduleSync();
  });

  mobileQuery.addEventListener?.('change', scheduleSync);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('.main-menu__toggle')) {
      cacheElements(event.target);
      scheduleSync();
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (
      event.target?.contains?.(toggle) ||
      event.target?.contains?.(content)
    ) {
      toggle = null;
      content = null;
      root.classList.remove('qls-mobile-menu-open');
    }
  });

  cacheElements();
  sync();
})();
